import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const BkFlowMaterialLoader = props => {
  const {
    parentClasses,
    loaderClasses,
    size,
    color
  } = props

  return (
    <div className={ parentClasses && parentClasses }>
      <CircularProgress
        size={ size ? size : 50 }
        style={ color ? { color: '#' + color } : { color: '#000'} }
        className={ loaderClasses ? loaderClasses : 'u-remove-margin' }
      />
    </div>
  )
}

export default BkFlowMaterialLoader



// WEBPACK FOOTER //
// ./src/components/elements/BkFlowMaterialLoader.js